import { render } from "./BusinessReviews.vue?vue&type=template&id=f730b6ec"
import script from "./BusinessReviews.vue?vue&type=script&lang=js"
export * from "./BusinessReviews.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__